<template>
    <v-container>
        <h1>Alarmas</h1>
        <v-card>
            <!-- Alarmas activas actualmente -->
            <v-container>
                <v-card v-if="items_activas.length > 0" >
                    <v-card-title>Actualmente activas</v-card-title>
                    <v-data-table class="activas" sort-by="hora_lectura" sort-desc  :headers="headers_activas" :items="items_activas"
                            :footer-props="{
                                'items-per-page-text':'Alarmas por página'
                            }">
                                <template v-slot:[`item.icono`]="{ item }">
                                <v-icon color="#db0d0d" class="mr-3">{{item.icono}}</v-icon>
                                </template>
                                <template v-slot:[`item.hora_lectura`]="{ item }">
                                   {{ formateo_fecha(item.hora_lectura)}}
                                </template>
                                <template v-slot:no-results>
                                    <span>No hay datos para esta búsqueda</span>
                                </template>
                    </v-data-table>
                </v-card>
                <v-card v-else>
                    <v-card-title>
                        Actualmente no se encuentra ninguna alarma activa
                    </v-card-title>
                </v-card>
            </v-container>
            <!-- Históricos de alarmas -->
            <v-container>
                <v-card>
                    <v-card-title>Históricos</v-card-title>
                    <div class="mb-4 mt-2 pl-3 pr-3">
                        <v-row class="justify-center">
                            <v-col cols="12" md="2">
                                <v-menu v-model="fechaInicioInput" :close-on-content-click="false" 
                                :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="fechaInicio"
                                            label="Fecha Inicio"
                                            prepend-icon="mdi-calendar"
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="fechaInicio" @input="fechaInicioInput = false"></v-date-picker>
                                </v-menu>
                            </v-col> 
                            <v-col cols="12" md="2">
                                <v-menu v-model="fechaFinInput" :close-on-content-click="false" 
                                :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="fechaFin"
                                            label="Fecha Fin"
                                            prepend-icon="mdi-calendar"
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="fechaFin" @input="fechaFinInput = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <!-- Descripcion -->
                            <v-col> 
                                <v-text-field v-model="descripcion" label="Descripcion" type=string> </v-text-field> 
                            </v-col>  
                        </v-row>
                        <v-row>       
                            <v-col cols="12" class="text-center"> 
                                <v-btn @click="buscar" block color="primary">
                                    <v-icon>BUSCAR</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>

                    <!-- Tabla de alarmas -->
                    <v-data-table :headers="headers" :items="items_historicos" :search="search" 
                        :loading="loading_historicos"
                        sort-by="fecha_activado" sort-desc
                        :footer-props="{
                            'items-per-page-text':'Alarmas por página'
                        }"
                        >
                        <template v-slot:[`item.fecha_activado`]="{ item }">
                            {{ formateo_fecha(item.fecha_activado)}}
                        </template>
                        <template v-slot:[`item.fecha_desactivado`]="{ item }">
                            {{ formateo_fecha(item.fecha_desactivado)}}
                        </template>
                        <template v-slot:no-results>
                            <span>No hay datos para esta búsqueda</span>
                        </template>
                    </v-data-table>
                </v-card>
            </v-container>
        </v-card>
    </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import moment from 'moment';
export default {
    data() {
        return {
            search: null,
            loading_historicos: true,
            headers: [
                { text: "ID", value: "id_alarma" },
                { text: "Descripción", value: "descripcion" },
                { text: "Activado", value: "fecha_activado" },
                { text: "Desactivado", value: "fecha_desactivado" },
                // { text: "Variable", value: "variable" },
            ],
            headers_activas: [
                { text: "", value: "icono" },
                { text: "ID", value: "id" },
                // { text: "Direccion", value: "direccion" },
                { text: "Descripción", value: "descripcion" },
                // { text: "PLC", value: "id_plc" },
                // { text: "Valor Actual", value: "valor_actual" },
                { text: "Activado", value: "hora_lectura" },
            ],
            // id: '',
            descripcion: '',
            fechaInicio: moment(Date.now()).subtract(1, 'days').format('YYYY-MM-DD'),
            fechaFin: moment(Date.now()).format('YYYY-MM-DD'),
            fechaInicioInput: false,
            fechaFinInput: false,
        };
    },
    computed: {
        ...mapState(['alarmas_activas', 'alarmas','historico_alarmas']),
        
        items_activas(){
            let alarmas = []
            if(this.alarmas.length > 0){
                this.alarmas_activas.forEach( e => {
                    let alarma = this.alarmas.find(alarma => alarma.id == e.id)
                    e.descripcion = alarma.descripcion
                    e.icono = 'mdi-alert'
                    alarmas.push(e)
                })
            }
            return alarmas
        },
        items_historicos(){
            let historicos = []
            this.historico_alarmas.forEach( alarma => {
                let nuevo = {}
                alarma.historico.forEach((e, index) => {      
                    nuevo.id_alarma = alarma.id_alarma
                    nuevo.descripcion= alarma.descripcion
                    if(e.estado != alarma.estado_correcto){// si es la fecha de activado
                        nuevo.fecha_activado = e.hora_lectura
                        if(index == (alarma.historico.length -1)){// si es el ultimo elemento, no se ha desactivado
                            historicos.push(nuevo)
                            nuevo = {}
                        }
                    }
                    else{// si es la fecha de desactivadp
                        nuevo.fecha_desactivado =  e.hora_lectura
                        historicos.push(nuevo)
                        nuevo = {}
                    }
                })
            })

            
            return historicos
        }
    },

    async mounted() {
        this.buscar()
        this.loading_historicos = false;
    },

    methods: {
        ...mapActions(['setHistoricosAlarmas']),
        ...mapActions('api', ['getHistoricoAlarmas']),
        compareByDate(a, b) {
            return a.fecha_activado - b.fecha_activado;
        },
        formateo_fecha(fecha){
            if(fecha!= null && fecha != undefined && fecha.length > 0){
                return moment(fecha).format('YYYY-MM-DD HH:MM:SS')
            }else return null
        },
        async buscar(){
            let params = {
                fechaInicio: this.fechaInicio,
                fechaFin: this.fechaFin,
                descripcion: this.descripcion,
            }
            let res = await this.getHistoricoAlarmas(params)
            this.setHistoricosAlarmas(res.data)
        },
    }
}
</script>
<style>
/* Set the background color of the table row to red */
.activas tbody tr {
    background-color:white!important;
    color:rgb(219, 13, 13);
}

/* Set the background color of the table row to transparent on hover */
.activas tbody tr:hover {
    cursor:default;
    background-color:white!important;
    color:rgb(219, 13, 13);

}

</style> 